export default __webpack_public_path__ + "static/sharukh-31f69f5cd21f436e29f4d16d32124ce6.jpg";